import { RootState } from "@/store/store";

import { AccumulatedCost } from "@/services/cloudchipr.api";
import { budgetDetailsAccumulatedCostEndpointSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsAccumulatedCostEndpointSelector";

export const budgetDetailsAccumulatedCostDataSelector = (
  state: RootState,
): AccumulatedCost | undefined => {
  return budgetDetailsAccumulatedCostEndpointSelector(state)?.data;
};
